import { useParams } from 'react-router-dom';

import { TFLoadingOverlay } from '@tf/ui';

import { useObjectUriByNodeId } from '@/core/api/legacy';
import { PaymentsTable } from '@/components/payments';

export const AccountPaymentsTable = () => {
	const { accountId } = useParams<{ accountId: string }>();

	const { data, isPending } = useObjectUriByNodeId(Number(accountId));

	if (isPending) {
		return <TFLoadingOverlay />;
	}

	return <PaymentsTable objectUri={data} />;
};
